module.exports = __webpack_public_path__ + "static/media/Camera27.acde74ac.jpg";